import api from "lib/api";
import apiFormData from "lib/apiFormData";

// LEAVE
export const getLeaveRequestPagingRequest = async (params) => {
  return await api.post("/v1/leaveRequest/getLeaveRequestPaging", params);
};
export const getLeaveRequestByIdRequest = async (params) => {
  return await api.post("/v1/leaveRequest/getLeaveRequest", params);
};

export const getWorkflowByRequestId = async (params) => {
  return await api.post("/v1/leaveRequest/getWorkflowByRequestId", params);
};

export const createLeaveRequest = async (params) => {
  return await apiFormData.post("/v1/leaveRequest/createLeaveRequest", params);
};
export const updateLeaveRequest = async (params) => {
  return await apiFormData.post("/v1/leaveRequest/updateLeaveRequest", params);
};
export const manageMyLeaveRequestStatus = async (params) => {
  return await api.post("/v1/leaveRequest/manageMyLeaveRequestStatus", params);
};

export const getOvertimeCondition = async (params = {}) => {
  return await api.post("/v1/overtimeCondition/getOvertimeCondition", params);
};

export const rejectFlowForHr = async (params = {}) => {
  return await api.post("/v1/requestApprove/rejectFlowForHr", params);
};

export const rejectFlowForCustomer = async (params = {}) => {
  return await api.post("/v1/requestApprove/rejectFlowForCustomer", params);
};

// OFFSITEWORKING
export const getOffsiteWorkRequestPagingRequest = async (params) => {
  return await api.post(
    "/v1/offsiteWorkRequest/getOffsiteWorkRequestPaging",
    params
  );
};
export const patchOvertimeRequest = async (params) => {
  return await api.post(
    "/v1/overtimeRequest/patchOvertimeRequest",
    params
  );
};
export const getOffsiteWorkRequestByIdRequest = async (params) => {
  return await api.post("/v1/offsiteWorkRequest/getOffsiteWorkRequest", params);
};

export const createOffsiteWorkRequest = async (params) => {
  return await apiFormData.post(
    "/v1/offsiteWorkRequest/createOffsiteWorkRequest",
    params
  );
};

export const updateOffsiteWorkRequest = async (params) => {
  return await apiFormData.post(
    "/v1/offsiteWorkRequest/updateOffsiteWorkRequest",
    params
  );
};
export const manageOffsiteWorkRequestStatus = async (params) => {
  return await api.post(
    "/v1/offsiteWorkRequest/manageOffsiteWorkRequestStatus",
    params
  );
};

// REDEEMTIME
export const getRedeemTimeRequestPagingRequest = async (params) => {
  return await api.post(
    "/v1/redeemTimeRequest/getRedeemTimeRequestPaging",
    params
  );
};
export const getRedeemTimeRequestByIdRequest = async (params) => {
  return await api.post("/v1/redeemTimeRequest/getRedeemTimeRequest", params);
};
export const createRedeemTimeRequest = async (params) => {
  return await apiFormData.post(
    "/v1/redeemTimeRequest/createRedeemTimeRequest",
    params
  );
};
export const updateRedeemTimeRequest = async (params) => {
  return await apiFormData.post(
    "/v1/redeemTimeRequest/updateRedeemTimeRequest",
    params
  );
};
export const manageRedeemTimeRequestStatus = async (params) => {
  return await api.post(
    "/v1/redeemTimeRequest/manageRedeemTimeRequestStatus",
    params
  );
};

// ENDORSETIME
export const getEndorseTimeRequestPagingRequest = async (params) => {
  return await api.post(
    "/v1/EndorseTimeRequest/getEndorseTimeRequestPaging",
    params
  );
};
export const getEndorseTimeRequestByIdRequest = async (params) => {
  return await api.post(
    "/v1/EndorseTimeRequest/getEndorseTimeRequest",
    params
  );
};
export const createEndorseTimeRequest = async (params) => {
  return await apiFormData.post(
    "/v1/EndorseTimeRequest/createEndorseTimeRequest",
    params
  );
};
export const updateEndorseTimeRequest = async (params) => {
  return await apiFormData.post(
    "/v1/EndorseTimeRequest/updateEndorseTimeRequest",
    params
  );
};
export const manageEndorseTimeRequestStatus = async (params) => {
  return await api.post(
    "/v1/EndorseTimeRequest/manageEndorseTimeRequestStatus",
    params
  );
};

// OVERTIME
export const getOvertimeRequestPagingRequest = async (params) => {
  return await api.post("/v1/overtimeRequest/getOvertimeRequestPaging", params);
};
export const getOvertimeRequestByIdRequest = async (params) => {
  return await api.post("/v1/overtimeRequest/getOvertimeRequest", params);
};
export const createOvertimeRequest = async (params) => {
  return await apiFormData.post(
    "/v1/overtimeRequest/createOvertimeRequest",
    params
  );
};
export const updateOvertimeRequest = async (params) => {
  return await apiFormData.post(
    "/v1/overtimeRequest/updateOvertimeRequest",
    params
  );
};
export const manageOvertimeRequestStatus = async (params) => {
  return await api.post(
    "/v1/overtimeRequest/manageOvertimeRequestStatus",
    params
  );
};

// COLLECT TIME
export const getCollectTimeRequestPagingRequest = async (params) => {
  return await api.post(
    "/v1/collectTimeRequest/getCollectTimeRequestPaging",
    params
  );
};

export const getCollectTimeRequestByIdRequest = async (params) => {
  return await api.post("/v1/collectTimeRequest/getCollectTimeRequest", params);
};

export const createCollectTimeRequest = async (params) => {
  return await apiFormData.post(
    "/v1/collectTimeRequest/createCollectTimeRequest",
    params
  );
};
export const updateCollectTimeRequest = async (params) => {
  return await apiFormData.post(
    "/v1/collectTimeRequest/updateCollectTimeRequest",
    params
  );
};
export const manageCollectTimeRequestStatus = async (params) => {
  return await api.post(
    "/v1/collectTimeRequest/manageCollectTimeRequestStatus",
    params
  );
};

// DOCUMENT REQUEST
export const getDocumentRequestPagingRequest = async (params) => {
  return await api.post("/v1/documentRequest/getDocumentRequestPaging", params);
};

export const getDocumentRequestByIdRequest = async (params) => {
  return await api.post("/v1/documentRequest/getDocumentRequest", params);
};

export const createDocumentRequest = async (params) => {
  return await api.post("/v1/documentRequest/createDocumentRequest", params);
};

export const updateDocumentRequest = async (params) => {
  return await api.post("/v1/documentRequest/updateDocumentRequest", params);
};
export const manageDocumentRequestStatus = async (params) => {
  return await api.post(
    "/v1/documentRequest/manageDocumentRequestStatus",
    params
  );
};

// CHANGE SHIFT
export const getChangeShiftRequestPagingRequest = async (params) => {
  return await api.post(
    "/v1/changeShiftRequest/getChangeShiftRequestPaging",
    params
  );
};
export const getChangeShiftRequestByIdRequest = async (params) => {
  return await api.post("/v1/changeShiftRequest/getChangeShiftRequest", params);
};
export const createChangeShiftRequest = async (params) => {
  return await api.post(
    "/v1/changeShiftRequest/createChangeShiftRequest",
    params
  );
};
export const updateChangeShiftRequest = async (params) => {
  return await api.post(
    "/v1/changeShiftRequest/updateChangeShiftRequest",
    params
  );
};
export const manageChangeShiftRequestStatus = async (params) => {
  return await api.post(
    "/v1/changeShiftRequest/manageChangeShiftRequestStatus",
    params
  );
};

// WITNESS LETTER
export const getWarningLetterPagingRequest = async (params) => {
  return await api.post(
    "/v1/warningLetterRequest/getWarningLetterRequestPaging",
    params
  );
};
export const getWarningLetterByIdRequest = async (params) => {
  return await api.post(
    "/v1/warningLetterRequest/getWarningLetterRequest",
    params
  );
};
export const createWarningLetterRequest = async (params) => {
  return await apiFormData.post(
    "/v1/warningLetterRequest/createWarningLetterRequest",
    params
  );
};
export async function previewWarningLetterPdf(params) {
  const { companyId, lang, ...body } = params;
  return await api.post(
    `/v1/warningLetterRequest/previewPdf?companyId=${companyId}`,
    body,
    { responseType: "blob" }
  );
}
export const updateWarningLetterRequest = async (params) => {
  return await apiFormData.post(
    "/v1/warningLetterRequest/updateWarningLetterRequest",
    params
  );
};
export const manageWarningLetterRequestStatus = async (params) => {
  return await api.post(
    "/v1/warningLetterRequest/manageWarningLetterRequestStatus",
    params
  );
};

export const getCollectTimeDropdown = async (params) => {
  return await api.post(
    "/v1/dropdown/getCollectTime",
    params
  );
};

export const getCompanyRegulation = async (params) => {
  return await api.post(
    "/v1/dropdown/getCompanyRegulation",
    params
  );
};

export const getCurrentShift = async (params) => {
  return await api.post(
    "/v1/changeShiftRequest/getCurrentTimePlanShift",
    params
  );
};

export const getAttendanceSettingShift = async (params) => {
  return await api.post(
    "/v1/dropdown/getAttendanceSettingShift",
    params
  );
};

export const deleteAllRequestByReqId = async (params) => {
  return await api.post("/v1/leaveRequest/deleteAllRequestByReqId", params);
};

// expense

export const getMyExpenseRequestPagination = async (params = {}) => {
  return await api.post("/v1/expense/getMyExpenseRequestPagination", params);
};

export const getMyTxnExpenseById = async (params = {}) => {
  return await api.post("/v1/expense/getTxnExpenseById", params);
};

export const dropdownProjectByEmployeeId = async (params = {}) => {
  return await api.post("v1/myTimeSheet/dropdownProjectByEmployeeId", params);
};

export const getEmployeeWelfareDropdown = async (params = {}) => {
  return await api.post("v1/employee/getEmployeeWelfareDropdown", params);
};

export const getCommonTypeByCode = async (params = {}) => {
  return await api.post("v1/dropdown/getCommonTypeByGroupType", params);
};

export const getDropdownWelfareSubTypeByCode = async (params = {}) => {
  return await api.post("/v1/dropdown/getWelfareSubTypeByCode", params);
};
export const getDropdownWorkInLocation = async (params = {}) => {
  return await api.post("/v1/stp/getDropdownWorkInLocation", params);
};

export const exportDocumentRequestPDF = async (params = {}) => {
  return await api.post("/v1/documentRequest/downloadSalaryCertificate", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};